type SpinnerIconProps = {
  width?: number | string;
  height?: number | string;
  color?: string;
  className?: string;
};

const SpinnerIcon = ({ width = 24, height = 24, color = 'currentColor', className }: SpinnerIconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    style={{ color: `var(${color})` }}
  >
    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeOpacity="0.2" />
    <circle
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="2"
      strokeDasharray="47 16"
      strokeLinecap="round"
      transform="rotate(-90 12 12)"
    />
  </svg>
);

export default SpinnerIcon;
